import { AsciiMapper } from '../mappers/ascii.mapper';

export class CnpjAlfanumericoValidator {

  private static readonly WEIGHTS_DV1 =
    [5,4,3,2,9,8,7,6,5,4,3,2];

  private static readonly WEIGHTS_DV2 =
    [6,5,4,3,2,9,8,7,6,5,4,3,2];

  static isValid(cnpj: string): boolean {
    if (!cnpj){
      return false;
    }

    const normalized = cnpj
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');

    if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(normalized))
      return false;

    const base = normalized.substring(0, 12);
    const dvInformado = normalized.substring(12);

    const dv1 = this.calculateDigit(base, this.WEIGHTS_DV1);

    const dv2 = this.calculateDigit(
      base + dv1,
      this.WEIGHTS_DV2
    );

    return dvInformado === `${dv1}${dv2}`;
  }

  private static calculateDigit(
    value: string,
    weights: number[]
  ): number {

    const sum = value
      .split('')
      .reduce((acc, char, index) => {
        return acc + AsciiMapper.toValue(char) * weights[index];
      }, 0);

    const remainder = sum % 11;

    return remainder < 2
      ? 0
      : 11 - remainder;
  }
}